import axiosOriginal from "axios";
import adapter from "axios/lib/adapters/xhr";
// import * as AxiosLogger from "axios-logger";
import { Service } from "axios-middleware";

const axios = axiosOriginal.create({ adapter });
// axios.interceptors.request.use(
//   request => request,
//   AxiosLogger.errorLogger,
// );

// axios.interceptors.response.use(
//   response => response,
//   async function (error) {
//     if (error?.response?.status === 401) {
//       console.warn("+++++401");
//       window.location = "/logout";
//     }
//     return Promise.reject(error);
//   },
// );

const service = new Service(axios);

service.register({
  onRequest(config) {
    // console.log("onRequest");
    return config;
  },
  onSync(promise) {
    // console.log("onSync");
    return promise;
  },
  onResponse(response) {
    // console.log("onResponse");
    return response;
  },
  onResponseError(error) {
    console.log("++ onResponseError");
    console.log(error);
    if (error?.response?.status === 401) {
      console.warn("+++++401");
      // window.location = "/logout";
      window.location.replace("/logout");
    }
   throw error;
  },
});

export default axios;
